import React, { useState } from 'react';

import { useSubscribeToNewsletter, useUnsubscribeFromNewsletter } from '@hooks';
import { Switch } from '@mui/material';

import StepContainer from './StepContainer';

export interface Newsletter {
  card_image_path: string;
  current_user_subscribed: boolean;
  frequency: string;
  id: number;
  name: string;
}

interface StepNewslettersProps {
  newsletters: Newsletter[];
  nextStep: () => void;
}

interface NewsletterItemProps {
  item: Newsletter;
  setError: (error: string) => void;
}

const StepNewsletters = ({ newsletters, nextStep }: StepNewslettersProps) => {
  const [error, setError] = useState<string>('');

  return (
    <StepContainer
      heading="Stay on Top of Tech News"
      subheading="Which newsletters do you want to receive?"
      nextStep={nextStep}
      error={error}
    >
      <ul className="onboarding-togglelist">
        {newsletters?.map((n) => <NewsletterItem key={n.name} item={n} setError={setError} />)}
      </ul>
    </StepContainer>
  );
};

const NewsletterItem = ({ item, setError }: NewsletterItemProps) => {
  const [status, setStatus] = useState(item.current_user_subscribed);
  const { mutate: subscribeToNewsletter, isLoading: isFollowNewsletterLoading } =
    useSubscribeToNewsletter();
  const { mutate: unsubscribeFromNewsletter, isLoading: isUnFollowNewsletterLoading } =
    useUnsubscribeFromNewsletter();

  const handleSwitchToggle = (event) => {
    try {
      setStatus(event.target.checked);
      setError('');
      const subscribeMethod = event.target.checked
        ? subscribeToNewsletter
        : unsubscribeFromNewsletter;
      subscribeMethod({ newsletter_id: event.target.value });
    } catch (err) {
      setStatus(!event.target.checked);
      setError(err.message);
    }
  };

  return (
    <li>
      <div className="onboarding-newsletter">
        <img src={`https://tii.imgix.net/production/${item.card_image_path}`} />
        <div>
          <span>{item.frequency}</span>
          <h3>{item.name}</h3>
        </div>
      </div>
      <Switch
        className="tiswitch"
        disableRipple
        checked={status}
        onChange={handleSwitchToggle}
        value={item.id}
        disabled={isFollowNewsletterLoading || isUnFollowNewsletterLoading}
      />
    </li>
  );
};

export default StepNewsletters;
